/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled from 'styled-components';

export const PageNewsManageContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
`;
